import { Calendar } from "primereact/calendar";
import PropTypes from "prop-types";
import { getErrorMessage } from "../form/FormStandardProps";
import Label from "./Label";

const DatePicker = ({
  className = "",
  disabled = false,
  input,
  label,
  meta: { touched, error },
  placeholder,
  readOnly = false,
  required = false,
  ...rest
}) => {

  const today = new Date();
  console.log("today", today);

  // const calenderInput=document.getElementsByClassName("edexlms-field-input")
  // calenderInput.dispatchEvent(new Event('input',{bubbles:true}))
  

  return (
    <div
      className={`edexlms-field text-input ${readOnly ? "readonly" : ""} ${
        disabled ? "disabled" : ""
      } `}
    >
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          htmlFor={input.name}
        />
      )) ||
        null}
      <Calendar 
        {...input}
        {...rest}
        minDate={today}
        disabled={disabled || readOnly}
        placeholder={placeholder}
         onChange={(e) => {
    input.onChange(e.value); // keep Final Form in sync ✅
    if (rest.onChange) rest.onChange(e.value); // call parent handler if provided ✅
  }}
        showIcon
        dateFormat="dd MM yy"
        invalid={touched && error}
        className={`edexlms-field-input w-full ${className}`}
      />
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, input, rest, label || placeholder)}
        </div>
      )) ||
        null}
    </div>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  meta: PropTypes.object,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
};

export default DatePicker;
